import React from 'react';
import {
  IonButton,
  IonContent,
  IonIcon,
  IonModal,
  IonText
} from '@ionic/react';
import { alertCircleOutline } from 'ionicons/icons';
import './SessionKilledModal.css';

interface SessionKilledModalProps {
  isOpen: boolean;
  killedBy: string;
  onLogin: () => void;
}

const SessionKilledModal: React.FC<SessionKilledModalProps> = ({ 
  isOpen, 
  killedBy, 
  onLogin 
}) => {
  return (
    <IonModal 
      isOpen={isOpen}
      backdropDismiss={false}
      className="session-killed-modal"
    >
      <div className="session-killed-container">
        <div className="session-killed-icon">
          <IonIcon 
            icon={alertCircleOutline} 
            color="danger" 
            size="large"
          />
        </div>
        
        <IonText color="dark" className="session-killed-title">
          <h2>Session Terminated</h2>
        </IonText>
        
        <IonText color="medium" className="session-killed-message">
          <p>
            Your session has been terminated by:
            <br />
            <strong>{killedBy || 'Administrator'}</strong>
          </p>
          <p>
            Please log in again to continue using the application.
          </p>
        </IonText>
        
        <IonButton 
          expand="block" 
          onClick={onLogin}
          className="session-killed-button"
        >
          Log In
        </IonButton>
      </div>
    </IonModal>
  );
};

export default SessionKilledModal; 